<div
    class="reclass-cell"
    [class.has-value]="hasValue"
    [class.negative]="isNegative"
    [class.disabled]="disabled"
    (click)="onClick($event)"
>
    <span class="reclass-value" *ngIf="hasValue">{{ value | number : '1.2-2' }}</span>
    <span class="reclass-placeholder" *ngIf="!hasValue">0.00</span>
    <span class="reclass-add" *ngIf="!disabled" aria-hidden="true">+</span>
</div>
